import { TextAnimationStep } from '../../element-editor/animation/text-animation.service';

export class TextAnimationFrameObject {
  // grid coordinates (column = along 'next', row = parallel depth)
  col = 0;
  row = 0;
  next?: TextAnimationFrameObject;
  paralell?: TextAnimationFrameObject;
  // opposite of paralell
  parent?: TextAnimationFrameObject;
  prev?: TextAnimationFrameObject;
  id: string;
  constructor(
    public frame: TextAnimationStep,
    private store: Record<string, TextAnimationFrameObject>,
  ) {
    this.id = Math.random().toString(36).slice(2, 9);
    this.store[this.id] = this;

    this.next = frame.next
      ? new TextAnimationFrameObject(frame.next, store)
      : undefined;
    // this.paralell = frame.paralell
    //   ? new TextAnimationFrameObject(frame.paralell, store)
    //   : undefined;
  }

  get fullFrame() {
    return {
      ...this.frame,
      next: this.next?.fullFrame,
      paralell: this.paralell?.fullFrame,
    };
  }

  get absX() {
    // 180px per column with 20px gutter
    return this.col * 180;
  }

  get absY() {
    // 110px per row with 10px gutter
    return this.row * 110;
  }

  get width() {
    return 160;
  }

  remove() {
    if (this.parent) {
      this.parent.paralell = this.paralell;
    }
    if (this.prev) {
      this.prev.next = this.next;
    }
    if (this.next) {
      this.next.prev = this.prev;
    }
    delete this.store[this.id];
  }

  static build(root: TextAnimationStep | undefined) {
    const store: Record<string, TextAnimationFrameObject> = {};
    const list: TextAnimationFrameObject[] = [];

    const createNode = (
      step: TextAnimationStep,
      col: number,
      row: number,
      prev?: TextAnimationFrameObject,
      parent?: TextAnimationFrameObject,
    ): TextAnimationFrameObject => {
      const node = new TextAnimationFrameObject(step, store);
      node.col = col;
      node.row = row;
      node.prev = prev;
      node.parent = parent;
      list.push(node);

      // if (step.paralell) {
      //   const par = createNode(step.paralell, col, row + 1, undefined, node);
      //   node.paralell = par;
      // }

      if (step.next) {
        const nxt = createNode(step.next, col + 1, row, node, parent);
        node.next = nxt;
      }

      return node;
    };

    const rootNode = root ? createNode(root, 0, 0) : undefined;
    return { root: rootNode, list, store };
  }
}
